import { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, ThemeName, useTheme } from '../../assets/theme';

export const ThemeControl = () => {
  const { themeName, toggleTheme } = useTheme();
  return (
    <SwitchThemeButton style={{ marginRight: '1rem' }} onClick={toggleTheme}>
      <FontAwesomeIcon
        title="Toggle theme"
        icon={[`fa${themeName === ThemeName.Light ? 'r' : 's'}` as IconPrefix, 'lightbulb']}
      />
    </SwitchThemeButton>
  );
};

export const SwitchThemeButton = styled.button`
  width: 2rem;
  height: 2rem;
  font-size: 1rem;
  line-height: 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  cursor: pointer;

  color: ${({ theme }) => theme.core.textColor};
  transition: background-color ${({ theme }) => theme.motion.duration}ms ${({ theme }) => theme.motion.easing};

  &:hover {
    background-color: ${({ theme }) => theme.button.secondary.active.backgroundColor};
    color: ${({ theme }) => theme.button.secondary.textColor};
  }
`;
